import { getActiveZones } from "./index23.js";
import { isBuildingEmpty } from "./index81.js";
import { addTechnicalSpaces } from "./index125.js";
import { RG_TYPE, SpacesList, checkRequiredSpaces } from "@project-rouge/rg-core";
import { getBuildingAttributes, getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const pipeAddTechSpaces = ([parent, { aggProps, techData = [], buildingIds }]) => {
	const dataset = aggProps.dataset;
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) {
		const aggZoneProps = aggProps.zones[zone.uuid];
		const buildings = getRgObjectsOfType$1(zone, RG_TYPE.Building);
		for (const building of buildings) {
			if (buildingIds && !buildingIds.includes(building.uuid)) continue;
			if (isBuildingEmpty(building)) continue;
			const buildingAttributes = getBuildingAttributes(building, {
				LevelHeight: dataset.aggConfig.f2fHeight,
				PodiumHeight: aggZoneProps.podium ? aggZoneProps.podium.height : 0,
				MaxModuleDepth: dataset.aggConfig.moduleDepth
			}, aggZoneProps.techSpaces.userDefinedAttributes);
			const forceInvalid = aggZoneProps.techSpaces.forceInvalid !== void 0 ? aggZoneProps.techSpaces.forceInvalid : true;
			const requiredSpaces = checkRequiredSpaces(buildingAttributes, SpacesList, aggZoneProps.techSpaces.optionalSpaces);
			const { consolidated, spacesAdded, invalid } = addTechnicalSpaces({
				building,
				buildingAttributes,
				requiredSpaces,
				forceInvalid,
				podiumProps: aggZoneProps.podium,
				dataset
			});
			techData.push({
				buildingID: building.uuid,
				spacesRequired: requiredSpaces,
				spacesAdded,
				spacesConsolidated: consolidated,
				errors: invalid
			});
		}
	}
	return [parent, void 0];
};
export { pipeAddTechSpaces };

//# sourceMappingURL=index126.js.map